module.exports = __webpack_public_path__ + "static/media/calendario.1952bc12.png";